import { StyledInput } from './Input.style';

interface Props {
    type?: string
    value?: string
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    placeholder?: string
    checked?: boolean
    hasError?: boolean
}

const Input: React.FC<Props> = ({ type = 'text', value, onChange, placeholder, checked, hasError}) => {
    return (
        <StyledInput
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            checked={checked}
            hasError={hasError}
        />
    );
};

export default Input;